"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _array = require("@widergy/web-utils/lib/array");

var _WithTheme = _interopRequireDefault(require("../WithTheme"));

var _theme = require("./theme");

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _Star = _interopRequireDefault(require("./components/Star"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var UTRatingStarContainer = function UTRatingStarContainer(_ref) {
  var stars = _ref.stars,
      field = _ref.field,
      onChange = _ref.onChange,
      classes = _ref.classes;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      selectedStars = _useState2[0],
      setSelectedStars = _useState2[1];

  var _useState3 = (0, _react.useState)([]),
      _useState4 = _slicedToArray(_useState3, 2),
      hoveredStars = _useState4[0],
      setHoveredStars = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      temporalSelected = _useState6[0],
      setTemporalSelected = _useState6[1];

  var handleStarClick = function handleStarClick(order, value) {
    setSelectedStars((0, _array.autocompleteWithNumbers)(1, order));
    if ((0, _array.isEmpty)(selectedStars)) setTemporalSelected((0, _array.autocompleteWithNumbers)(1, order));
    onChange(value.toString());
  };

  var handleStarHover = function handleStarHover(value) {
    setHoveredStars((0, _array.autocompleteWithNumbers)(1, value));
    setSelectedStars([]);
  };

  var handleMouseLeave = function handleMouseLeave() {
    setHoveredStars([]);
    setSelectedStars(temporalSelected);
  };

  var handleMapStars = function handleMapStars(star) {
    return _react["default"].createElement(_Star["default"], {
      hovered: hoveredStars.includes(star.order),
      selected: selectedStars.includes(star.order),
      onMouseLeave: handleMouseLeave,
      onHover: handleStarHover,
      onClick: handleStarClick,
      value: star.value,
      order: star.order,
      isFirst: stars[0].order === star.order,
      isLast: stars.length === star.order,
      textVariant: field.configuration && field.configuration.text_variant,
      name: star.name,
      starColor: field.configuration && field.configuration.star_color,
      classes: classes
    });
  };

  return _react["default"].createElement("div", {
    className: _stylesModule["default"].container
  }, stars.map(handleMapStars));
};

UTRatingStarContainer.propTypes = {
  stars: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    order: _propTypes.number,
    value: _propTypes.number
  })),
  onChange: _propTypes.func,
  field: _propTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  classes: _propTypes.any
};

var _default = (0, _WithTheme["default"])(_theme.retrieveStyle)(UTRatingStarContainer);

exports["default"] = _default;